export default __webpack_public_path__ + "static/media/banner.131923fc.svg";